<script lang="ts">
    export let hideRatingHeader = true;
</script>

<div class="gw-rv-listing-layout__header">
    <div class="gw-rv-listing-layout__header-main">
        {#if !hideRatingHeader}
            <div class="gw-rv-listing-layout__rating">
                <div class="gw-rv-listing-layout__avg">
                    <div class="gw-rv-listing-layout__avg-bar">
                        <span class="gw-rv-listing-layout__avg-bar-text">
                            <slot name="avg" />
                        </span>
                        <span
                            class="gw-rv-listing-layout__avg-bar-max-rate-text"
                        >
                            /5
                        </span>
                    </div>

                    <slot name="rating" />

                    <span class="gw-rv-listing-layout__rate-count-block">
                        <slot name="count" />
                    </span>
                </div>
                <div class="gw-rv-listing-layout__rating-progress">
                    <div class="gw-rv-listing-layout__progress-bars">
                        <slot name="progress-bars" />
                    </div>
                </div>
            </div>
        {/if}
        <div class="gw-rv-listing-layout__buttons">
            <slot name="actions" />
        </div>
    </div>
</div>

<style lang="postcss">
    .gw-rv-listing-layout__header-main {
        display: flex;
        justify-content: space-between;
        gap: 1em;
        flex-wrap: wrap;
    }

    .gw-rv-listing-layout__rating {
        flex-basis: 26em;
        display: flex;
        gap: 2.1875em;
        flex-wrap: wrap;
        align-items: center;
    }

    .gw-rv-listing-layout__rating-progress {
        flex: 1;
    }

    .gw-rv-listing-layout__rate-count-block {
        display: flex;
        font-size: 0.875em;
        margin-top: 0.375em;
        line-height: 1.188em;
        white-space: nowrap;
        letter-spacing: normal;
        font-weight: 600;
    }

    .gw-rv-listing-layout__avg {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .gw-rv-listing-layout__avg-bar {
        width: 100%;
        text-align: center;
        padding: 0.75em;
    }

    .gw-rv-listing-layout__avg-bar-text {
        font-size: 3.813em;
        line-height: 1;
    }

    .gw-rv-listing-layout__avg-bar-max-rate-text {
        font-size: 1.938rem;
    }

    .gw-rv-listing-layout__progress-bars {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .gw-rv-listing-layout__buttons {
        display: flex;
        align-content: flex-start;
        gap: 0.3125em;
        flex-wrap: wrap;
        margin-left: auto;
        --gw-theme__text-color: var(--gw-rv-theme-secondaryColor);
    }

    @media all and (max-width: 956px) {
        .gw-rv-listing-layout__rating {
            flex-basis: 100%;
        }
    }
</style>
